"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;




































































































var _department = _interopRequireDefault(require("@/components/Cascader/department.vue"));
var _formatter = require("@/utils/formatter");
var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Department: _department.default }, data: function data() {return { tableData: [], // 列表数据
      newadd: false, // 新增弹窗
      tableColumns: [{ prop: 'insName', label: '组织名称', isShow: true }, // {
      //   prop: 'parentName',
      //   label: '上级名称',
      //   isShow: true
      // },
      // {
      //   prop: 'level',
      //   label: '级别',
      //   isShow: true
      // },
      // {
      //   prop: 'isEnd',
      //   label: '是否末级',
      //   formatter: isEndFormatter,
      //   isShow: true
      // },
      { prop: 'status', label: '状态', formatter: _formatter.statusFormatter, isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }], title: '新增', addData: { // 新增数据
        id: '', parentId: 0, // 父级ID
        parentName: '', // 父级名称
        insName: '', target: 'frmright', level: '1', status: '1', isEnd: '0' }, addDefault: { // 新增数据
        id: '', parentId: 0, // 父级ID
        parentName: '', // 父级名称
        insName: '', target: 'frmright', level: '1', status: '1', isEnd: '0' }, level: [], child: [], twoShow: false, twoSelect: 0, updateData: { id: '', parentId: 0, // 父级ID
        parentName: '', // 父级名称
        insName: '', target: 'frmright', level: '', status: '1', isEnd: '0' }, update: false, hasUrl: false, newTwoData: { parentId: 0, // 父级ID
        parentName: '', // 父级名称
        insName: '', target: 'frmright', level: '1', status: '1', isEnd: '0' }, rules: { insName: [{ required: true, message: '请输写组织名称', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.init();self.getOneLeve();}, methods: { init: function init() {var self = this;self.getData('/api/institution/list', {}, function (res) {self.tableData = res;});}, checkPermission: _user.checkPermission, getOneLeve: function getOneLeve() {// 获取一级菜单
      var self = this;self.getData('/api/menu/level?level=1&parentId=0', {}, function (res) {self.level = res;});}, onCencal: function onCencal() {this.newadd = false;this.twoSelect = 0;this.twoShow = false;this.$refs['addForm'].resetFields();}, closeRefund: function closeRefund(done) {// 重置新增列表
      this.twoSelect = 0;this.twoShow = false;this.$refs['addForm'].resetFields();done();}, onSubmit: function onSubmit() {// 提交
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var insi = self.addData.parentId;
          console.log('insi', insi);
          var postData = {
            insName: self.addData.insName,
            isEnd: self.addData.isEnd,
            level: self.addData.level,
            parentId: insi,
            parentName: self.addData.insName,
            status: self.addData.status };

          console.log('postData.level', postData.level);
          console.log('postData.parentId', postData.parentId);
          self.postData('/api/institution/add', postData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.init();
            self.getOneLeve();
            self.onCencal();
            // window.location.reload()
          });
        } else {
          return false;
        }
      });
    },
    onUpdate: function onUpdate(item) {// 编辑提交
      var self = this;
      self.$refs.updateForm.validate(function (valid) {
        if (valid) {
          self.$confirm('确定修改该记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true }).
          then(function () {
            var insi = self.updateData.parentId;
            var postData = {
              insName: self.updateData.insName,
              level: self.updateData.level,
              parentId: insi,
              parentName: self.updateData.parentName,
              id: self.updateData.id,
              status: self.updateData.status };

            self.putData('/api/institution/edit/' + self.updateData.id, postData, function (res) {
              self.$message({
                message: '修改成功!',
                type: 'success' });

              self.init();
              self.getOneLeve();
              self.onCancelUpdate();
            });
          }).catch(function () {});
        } else {
          return false;
        }
      });
    },
    onCancelUpdate: function onCancelUpdate() {
      this.update = false;
      this.$refs['updateForm'].resetFields();
    },
    updateMenu: function updateMenu(item) {// 编辑弹窗
      console.log(item);
      this.update = true;
      this.updateData = JSON.parse(JSON.stringify(item));
    },
    delMenu: function delMenu(delId) {// 删除记录
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/institution/del/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.init();
          self.getOneLeve();
        });
      }).catch(function () {});
    },
    addMenu: function addMenu() {// 新增弹窗
      var self = this;
      self.addData = JSON.parse(JSON.stringify(self.addDefault));
      self.newadd = true;
    },
    changeDepartment: function changeDepartment(val) {
      this.addData.level = val.length + 1;
      this.addData.parentId = val;
      this.updateData.level = val.length;
      this.updateData.parentId = val;
      console.log('val11', val);
    } } };exports.default = _default;